import TooltipLabelSingle from "../tooltip/TooltipLabelSingle";
import * as vendorTooltip from "../ui/tooltips/DefaultTooltip";
import styles from "./LabelSingle.module.scss";

function LabelSingle({ label, uuid }) {
  return (
    <>
      <div
        id={`label-single-${uuid}-${label}`}
        className={styles["label"]}
        data-tooltip-id={`label-single-${uuid}-${label}`}
        data-tooltip-delay-show={vendorTooltip.getTimeFast()}>
        {label}
      </div>
      <TooltipLabelSingle label={label} handle={`label-single-${uuid}-${label}`} />
    </>
  );
}

export default LabelSingle;
